import styled from 'styled-components/native';
import style, { hpx, wpx } from '../../styles';
import { ReactComponent as SearchIcon } from '../../Assets/Images/search.svg';

export const Container = styled.View`
  background: ${style.colors.white};
`;

export const CoverContainer = styled.View`
  background-size: contain;
  div {
    background-size: contain;
  }
`;

export const Cover = styled.ImageBackground`
  width: 100%;
  height: 250px;
  background-size: contain;
  @media (max-width: 768px) {
    height: 90px;
  }
`;

export const PhoneContainer = styled.View`
  flex-direction: row;
  justify-content: space-around;
`;

export const PhoneNumberButton = styled.TouchableOpacity`
  background: ${props => props.theme.colors.primary};
  border-radius: 8px;
  padding: 12px;
  flex: 1;
  text-align: center;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin-horizontal: 5px;
`;

export const PhoneNumber = styled.Text`
  color: ${props => props.theme.colors.secondary};
  font-size: ${style.fonts.medium};
  font-family: ${style.fontName.ubuntuRegular};
`;

export const Address = styled.Text`
  font-size: ${style.fonts.xsmall};
  color: #555;
  font-family: ${style.fontName.ubuntuRegular};
  flex: 1;
`;

export const Name = styled.Text`
  font-family: ${style.fontName.ubuntuBold};
  color: ${props => props.theme.colors.primary};
  font-size: 28px;
  margin-bottom: 2px;
`;

export const AddressContainer = styled.TouchableOpacity`
  flex-direction: row;
  padding-vertical: 12px;
  align-items: center;
`;

export const AddressIcon = styled.Image`
  width: 25px;
  height: 15px;
  resize-mode: contain;
  margin-right: 5px;
`;

export const TextContainer = styled.View`
  padding: 16px 20px;
  font-family: ${style.fontName.ubuntuRegular};
`;

export const SelectorContainer = styled.View`
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: ${hpx(8)};
`;

export const IconImage = styled.Image`
  width: 20px;
  height: 20px;
  resize-mode: contain;
  margin-right: 10px;
`;

export const MapLink = styled.Text`
  text-decoration: underline;
  font-size: ${style.fonts.xxsmall};
  color: ${props => props.theme.colors.primary};
`;

export const SearchContainer = styled.View`
  padding: 12px 14px;
  border-width: 1px;
  border-color: #E5E5E5;
  margin: 0 20px 12px;
  border-radius: 8px;
  flex-direction: row;
  align-items: center;
  background-color: #FAFAFA;
`;

export const Search = styled.TextInput`
  flex: 1;
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline-color: transparent;
  outline-style: none;
  color: #666;
  font-size: ${style.fonts.xsmall};
  font-family: ${style.fontName.ubuntuRegular};
`;

export const MoreInformationContainer = styled.View`
  margin-top: 5px;
`;

export const MoreInformationHidden = styled.View`
  border-top-width: 1px;
  border-top-color: #F0F0F0;
  padding-top: 5px;
`;

export const Description = styled.Text`
  color: #666;
  font-size: ${style.fonts.xsmall};
  font-family: ${style.fontName.ubuntuRegular};
  line-height: 22px;
  margin-top: 6px;
`;
